import http from './http.service';

class FormSurveyService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/dynamicForms";
    }

    loadEmptyFormStructure(formToRegisterEntityId) {
        if (!formToRegisterEntityId) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/${formToRegisterEntityId}/structure`);
    };

    loadFormStructureWithEntities(formToRegisterEntityId, entryId) {
        if (!formToRegisterEntityId) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/${formToRegisterEntityId}/values/${entryId}`);
    };

    checkCompletePermissions(formToRegisterEntityId) {
        if (!formToRegisterEntityId) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/checkCompletePermissions`, {
            params: {
                formToRegisterEntityId: formToRegisterEntityId
            }
        });
    };

    alreadyCompleted(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/alreadyCompleted`, {
            params: {
                id: id
            }
        });
    };

    deleteFormToEventEntity(id, eventId) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteFormToEventEntity`, { params: { id: id, eventId: eventId } });
    }

    deleteFormWithFormToEventEntity(id, eventId) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteFormWithFormToEventEntity`, { params: { id: id, eventId: eventId } });
    }

    deleteFormWithRelatedRecords(id, eventId) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteFormWithRelatedRecords`, { params: { id: id, eventId: eventId } });
    }

    addToEvent(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/addToEvent`, model);
    }

    updateAddedToEvent(model) {
        if (!model) {
            throw new Error('Model is required');
        }

         return this.$http.put(`${this.baseUrl}/updateAddedToEvent`, model);
    }

    actiavateFormToEventEntity(id, eventId) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/actiavateFormToEventEntity`, { params: { id: id, eventId: eventId } });
    }

    deactivateFormToEventEntity(id, eventId) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivateFormToEventEntity`, { params: { id: id, eventId: eventId } });
    }

    deleteForm(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteForm`, { params: { id: id } });
    }

    realDeleteForm(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/realDeleteForm`, { params: { id: id } });
    }

    validateUniqueFormName(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/validateUniqueFormName`, model);
    }

    lecturers(formToRegisterEntityId) {
        return this.$http.get(`${this.baseUrl}/lecturers`, {
            params: {
                formToRegisterEntityId: formToRegisterEntityId
            }
        });
    }

    participants(formToRegisterEntityId) {
        return this.$http.get(`${this.baseUrl}/participants`, {
            params: {
                formToRegisterEntityId: formToRegisterEntityId
            }
        });
    }

    addLecturers(lecturers) {
        if (!lecturers) {
            throw new Error('Lecturers is required');
        }

        return this.$http.post(`${this.baseUrl}/addLecturers`, lecturers);
    }

    addParticipants(participants) {
        if (!participants) {
            throw new Error('Participants is required');
        }

        return this.$http.post(`${this.baseUrl}/addParticipants`, participants);
    }
}

export default new FormSurveyService();
